export default {
  title: {
    id: 'notifications.screen.title',
    defaultMessage: 'Notifications',
  },
};
